module.exports = __webpack_public_path__ + "img/banner-escritorio.911e39be.jpg";